import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/global.css'
/*导入ui的包*/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import request from "@/utils/request";
/*使用ui*/
Vue.use(ElementUI, { size: 'small' });

Vue.config.productionTip = false
//定义全局的请求对象
Vue.prototype.$request = request;

Vue.prototype.$baseUrl=process.env.VUE_APP_BASEURL
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
